import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./payment.scss";
import { useDispatch, useSelector } from "react-redux";
import { IoIosWarning } from "react-icons/io";
import axios from "axios";
import Succsess from "../../components/payment/Succsess";
import CheckoutForm from "../../components/checkOut/CheckoutForm";
import { FaCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { updateQuantity } from "../../redux/cartReducer";
import Loading from "../../components/loading/Loading";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import InstantPaymentForm from "../../components/paymentGatway/InstantPaymentForm";
import { AuthContext } from "../../context/AuthContext";

const stripePromise = loadStripe(
  //"pk_test_51NZq6pLFX6mtMcpciNIeYaQr9QitCI3ub5rM7PMxOssHARVy2Xnn7tMOntsbROiypBXvOFP4ETaG3NqH86J6E4yH006NK19FAZ"
  "pk_live_51ShldZEYzr8Q8MTlMAD3ZJrzXnyu1Gza6wcSufOlr6XFcy1e7odf6d4CSYSx75rf8V0oKj2jrVgtE2ie7ISCDz0D00SG556bfa"
);

const Payment = () => {
  const { buyer } = useContext(AuthContext);
  const [fullName, setFullName] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [landmark, setLandmark] = useState("");
  const [address, setAddress] = useState("");
  const [homeName, setHomeName] = useState("");
  const [phone, setPhone] = useState("");
  const [orderId, setOrderId] = useState("");
  const [status, setStatus] = useState("pending");
  const [qrCode, setQrCode] = useState(null);
  const dispatch = useDispatch();
  const [varifyMail, setVarifyMail] = useState(false);
  const [orderCreated, setOrderCreated] = useState(false);
  const history = useNavigate();
  const [apiLoading, setApiLoading] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const navigate = useNavigate();
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentMethord, setPaymentMethord] = useState("");
  const [
    destination_address_mobile_number,
    setDestination_address_mobile_number,
  ] = useState("");

  const [destination_address_house_no, setDestination_address_house_no] =
    useState("");
  const [destination_address_area, setDestination_address_area] = useState("");
  const [destination_address_landmark, setDestination_address_landmark] =
    useState("");
  const [destination_address_city, setDestination_address_city] = useState("");

  const [customer_reference_number, setCustomer_reference_number] =
    useState("");

  const [showCheckout, setShowCheckout] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const [sessionId, setSessionId] = useState(null);

  const generateUniqueNumber = () => {
    const uniqueNumber = "OCH-" + Date.now();
    setOrderId(uniqueNumber);
  };

  setTimeout(() => {
    setError("");
  }, 50000);

  // const devApiLink = "http://localhost:4047/api/v1";

  const devApiLink = "https://chocodate-api.notionspromos.com/api/v1";

  // console.log(varifyMail);

  useEffect(() => {
    if (!qrCode) {
      return;
    }

    const getVarifyCode = async () => {
      setLoading(true);
      try {
        await axios
          .get(`${devApiLink}/varifyCode/${qrCode}`)
          .then((response) => {
            const isCodeValid = response.data.code;
            setApiResponse(isCodeValid);
          });
      } catch (error) {
        setError("Code not valid or Already Used");
      } finally {
        setLoading(false);
      }
    };

    getVarifyCode();
  }, [qrCode]);

  const statusCode = () => {
    if (apiResponse?.qr) {
      return <FaCheckCircle color="#39e75f" />;
    }
    if (qrCode === null && !apiResponse?.qr) {
      return;
    }
    if (!apiResponse?.qr) {
      return (
        <div
          style={{
            padding: "5px 10px",
            backgroundColor: "red",
            color: "#00000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <strong
            style={{
              fontSize: "12px",
              color: "white",
              fontWeight: 600,
            }}
          >
            wrong code or code already used
          </strong>
        </div>
      );
    }
    if (loading) {
      return <small>Loading... </small>;
    } else {
      return;
    }
    return null; // Ensures the function always returns something, even if no conditions are met
  };

  const gift = () => {
    if (
      apiResponse?.winItemName === "Mobile Phone" ||
      apiResponse?.winItemName === "GOLD COIN" ||
      apiResponse?.winItemName === "2 Movie Ticket" ||
      apiResponse?.winItemName === "1 Free Family pack"
    ) {
      return (
        <span style={{ fontSize: "13px" }}>
          Contact support@notionsgroup.com to claim your prize!
        </span>
      );
    }

    if (apiResponse?.winItemName === "50% Off on next order") {
      return <span>Enjoy 50% off your total purchase!</span>;
    }

    // Default return when none of the above conditions match
    return <span>{apiResponse?.winItemName}</span>;
  };

  useEffect(() => {
    generateUniqueNumber();
  }, []);

  useEffect(() => {
    if (!email) {
      return;
    } else {
      const checkMail = apiResponse?.userEmail === email;
      setVarifyMail(checkMail);
    }
  }, [email]);

  const products = useSelector((state) => state.cart.products);

  const delivaryAmout = 20;
  const delivaryAmoutLess = 10;
  const noDelivaryAmout = 0;

  const totals = products.reduce(
    (acc, product) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity, 10);

      acc.totalPrice += price * quantity;
      acc.totalItems += quantity;

      return acc;
    },
    { totalPrice: 0, totalItems: 0 }
  );

  const netOderBefore = totals.totalPrice;

  const addCoupon = () => {
    if (!apiResponse?.winItemName) {
      return;
    }
    if (
      apiResponse?.winItemName === "50% Off on next order" &&
      varifyMail === true
    ) {
      const value = netOderBefore / 2;
      return value;
    } else {
      return;
    }
  };

  const addCouponValue = parseInt(addCoupon());

  //console.log(buyer);

  const finalVale = () => {
    if (!addCouponValue) {
      return netOderBefore;
    } else {
      const couponValue = netOderBefore - Number(addCouponValue);
      return couponValue;
    }
  };

  const netOder = finalVale();

  const withDelivaryCost = () => {
    let netTotal;
    if (netOder < 50) {
      netTotal = netOder + delivaryAmout;
    } else if (netOder >= 50 && netOder < 75) {
      netTotal = netOder + delivaryAmoutLess;
    } else if (netOder >= 75) {
      netTotal = netOder + noDelivaryAmout;
    } else {
      return; // Return nothing if no conditions are met
    }

    return netTotal.toFixed(2); // Ensures the value is fixed to two decimal places
  };

  const getdeliveryCost = () => {
    if (netOder < 50) {
      return 20;
    } else if (netOder >= 50 && netOder < 75) {
      return 10;
    } else {
      return 0;
    }
  };
  const deliveryCost = getdeliveryCost();

  // const finalCost = withDelivaryCost()

  const finalCost = withDelivaryCost();

  // console.log("finalCost", finalCost);

  const productsData = {
    totals: finalCost,
    qut: totals.totalItems,
    fullName,
    email,
    price: finalCost,
    name: fullName,
    title: fullName,
    quantity: totals.totalItems,
  };

  const hanldPlaceOrder = async () => {
    if (!paymentMethord || paymentMethord === "") {
      setError("Select your payment method");
      return;
    }

    const orderData = {
      fullName: fullName,
      email: email,
      products,
      brand: "Ochoco",
      // brand: "snacksfactory",
      num_pieces: productsData.qut,
      totalAmount: productsData.totals,
      descripon: products.title,
      city: city,
      buyerId: buyer?._id,
      landmark: landmark,
      address: address,
      homeName: homeName,
      orderId,
      phone: phone,
      deliveryCost,
      sessionId,
      paymentMethod: paymentMethord,
    };

    try {
      setBtnLoading(true);
      const res = await axios.post("/create_order", orderData);
      if(buyer){
        navigate(`/complete?OrderId=${orderId}}`);
      }
      return res;
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const showCheckoutSection = (e) => {
    e.preventDefault();
    setShowCheckout(true);
  };

  const massageDisplay_75 = () => {
    if (netOder < 75) {
      let value = 75 - netOder;
      return ` You're just AED ${value.toFixed(2)} away from free delivery! `;
    } else {
      return " 🥳  Woo.. hoo.. you're eligible for free delivery 🚚 ";
    }
  };

  const massgeDisplay_50 = () => {
    if (netOder < 50) {
      let valueTwo = 50 - netOder;
      return `  Or,Add just AED ${valueTwo.toFixed(
        2
      )} to slash your delivery fee to AED 10. `;
    } else {
      return;
    }
  };

  const inital = netOder === 0 ? "hide" : "";

  const handlePopUpActive = () => {
    setPopUp(true);
  };

  const handlePopUpClose = () => {
    setPopUp(false);
  };

  const options = {
    appearance: {
      theme: "flat",
      variables: {
        colorPrimary: "#0570de",
        colorBackground: "#ffffff",
        colorText: "#30313d",
        colorDanger: "#df1b41",
        fontFamily: "Ideal Sans, system-ui, sans-serif",
        spacingUnit: "2px",
        borderRadius: "4px",
      },
      rules: {
        ".Tab": {
          border: "1px solid #E0E6EB",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03)",
        },
        ".Tab:hover": {
          color: "var(--colorText)",
        },
        ".Tab--selected": {
          borderColor: "#E0E6EB",
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)",
        },
      },
    },
  };
  const amount = withDelivaryCost();
  useEffect(() => {
    if (buyer) {
      setFullName(buyer.fullName || "");
      setEmail(buyer.email || "");
      setPhone(buyer.phone || "");
      setCity(buyer.city || "");
      setAddress(buyer.address || "");
      // you can set more fields if needed
    }
  }, [buyer]);

  return (
    <div className="__fw">
      <div className="__mw">
        {apiLoading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            <div className="max-width">
              {status !== "complete" ? (
                <>
                  <div className="payment">
                    <div className="pay_info">
                      <div className="pro_list">
                        <div className="pro_hed">
                          <h5>
                            Order <em>summary</em>{" "}
                          </h5>
                        </div>
                        {products.length > 0 ? (
                          <div className="all_pro_list">
                            {products.map((product, index) => (
                              <div className="pro_card" key={index}>
                                <div className="pro_card_in">
                                  <div className="img_wrp">
                                    <img
                                      src={
                                        `${process.env.REACT_APP_DOC_VIEW_LINK}/` +
                                        product.img
                                      }
                                      alt=""
                                    />
                                  </div>
                                  <div className="info_wrp">
                                    <span>
                                      <em>{product.title}</em>
                                    </span>
                                    <br />
                                    <span>
                                      <small style={{ fontSize: "12px" }}>
                                        {product.quantity} kg X {product.price}{" "}
                                        AED = {product.quantity * product.price}{" "}
                                        AED
                                      </small>
                                    </span>
                                  </div>

                                  {/* <div className="info_wrp">
                                    <span>
                                      <em>AED </em>{" "}
                                      {(
                                        product.price * product.quantity
                                      ).toFixed(2)}
                                    </span>
                                  </div> */}
                                  <div className="qut_wrp">
                                    <button
                                      className="_btn"
                                      onClick={() =>
                                        dispatch(
                                          updateQuantity({
                                            id: product.id,
                                            quantity:
                                              product.quantity <= 5
                                                ? 5
                                                : product.quantity - 5,
                                          })
                                        )
                                      }
                                    >
                                      -
                                    </button>

                                    <strong
                                      style={{
                                        margin: "0px 20px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {product.quantity} kg
                                    </strong>

                                    <button
                                      className="_btn"
                                      onClick={() =>
                                        dispatch(
                                          updateQuantity({
                                            id: product.id,
                                            quantity: product.quantity + 5,
                                          })
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                                {/* <div className="pro_des">
                          <em>{product.desc}</em>
                        </div> */}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No products in the cart</p>
                        )}
                        {/* <div className="total_wrp bg">
                          <span>Have coupon ? </span>
                          <span>{statusCode()}</span>
                          <input
                            value={qrCode}
                            onChange={(e) => setQrCode(e.target.value)}
                            placeholder="ABC123"
                            type="text"
                          />
                        </div> */}
                        {!apiResponse ? (
                          <>{/* <Loading /> */}</>
                        ) : (
                          <>
                            <div
                              style={{ backgroundColor: "rgb(57, 231, 95)" }}
                              className="total_wrp"
                            >
                              <span
                                style={{ color: "white", fontWeight: "600" }}
                              >
                                {gift()}
                              </span>
                              <em
                                style={{
                                  fontStyle: "normal",
                                  fontSize: "10px",
                                  marginLeft: "10px",
                                }}
                              >
                                {!varifyMail &&
                                  "Alos use your registered email on Always a winner! to get exclusive discounts!"}
                              </em>
                            </div>
                          </>
                        )}
                        <div className="total_wrp">
                          <span>Items Total</span>
                          <span>AED {netOderBefore?.toFixed(2)}</span>
                        </div>
                        {apiResponse && (
                          <>
                            {varifyMail && (
                              <>
                                <div className="total_wrp">
                                  <span>Discount value </span>
                                  <span style={{ color: "red" }}>
                                    AED ( {addCouponValue?.toFixed(2)} )
                                  </span>
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {varifyMail === true && (
                          <div className="total_wrp">
                            <span>Sub Total</span>
                            <span>AED {netOder.toFixed(2)}</span>
                          </div>
                        )}

                        <div className="total_wrp">
                          <span>Delivery Charges</span>
                          <span>AED {deliveryCost.toFixed(2)}</span>
                        </div>
                        <hr />
                        <div className="total_wrp">
                          <h4>Total</h4> <h4>AED {withDelivaryCost()}</h4>{" "}
                        </div>
                      </div>
                      <div className="msgShow">
                        <span style={{ fontWeight: 400 }}>
                          {massageDisplay_75()}
                          {massgeDisplay_50()}
                          Don't miss out—shop a little more and save big!
                        </span>
                      </div>
                    </div>
                    <div className="check_right">
                      <div className="check_form">
                        <div>
                          <strong>Customer details</strong>
                        </div>
                        <div className="form">
                          <div className="from_wrp">
                            <div className="input_wrp">
                              <label>Full name</label>
                              <input
                                required
                                type="text"
                                value={buyer ? buyer.fullName : fullName}
                                onChange={(e) => setFullName(e.target.value)}
                              />
                            </div>
                            <div className="input_wrp">
                              <label>Email</label>
                              <input
                                required
                                type="text"
                                value={buyer ? buyer.email : email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="from_wrp">
                            <div className="input_wrp">
                              <label>Phone Number</label>
                              <input
                                required
                                value={buyer ? buyer.phone : phone}
                                type="text"
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="from_wrp">
                            <div className="input_wrp">
                              <label>City</label>
                              <input
                                name="city"
                                class="form-control save_data"
                                id="city"
                                value={buyer ? buyer.city : city}
                                required="required"
                                onChange={(e) => setCity(e.target.value)}
                              />
                            </div>

                            <div className="input_wrp">
                              <label>Address</label>
                              <input
                                required
                                type="text"
                                value={buyer ? buyer.address : address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="from_wrp">
                            <div className="input_wrp">
                              <label>House No. or Name</label>
                              <input
                                required
                                type="text"
                                value={homeName}
                                onChange={(e) => setHomeName(e.target.value)}
                              />
                            </div>
                            <div className="input_wrp">
                              <label>Landmark</label>
                              <input
                                required
                                type="text"
                                value={landmark}
                                onChange={(e) => setLandmark(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="payment_methord">
                            <h6>Select payment method</h6>
                            <div className="p_in">
                              {buyer && (
                                <div className="_p_wrp">
                                  <input
                                    type="radio"
                                    value="cod"
                                    checked={paymentMethord === "cod"}
                                    onChange={(e) =>
                                      setPaymentMethord(e.target.value)
                                    }
                                  />{" "}
                                  <strong>COD</strong>
                                </div>
                              )}
                              {!fullName || !email || !phone || !address ? (
                                <div className="_p_wrp">
                                  <input
                                    type="radio"
                                    value="card"
                                    disabled
                                    checked={paymentMethord === "card"}
                                    onChange={(e) =>
                                      setPaymentMethord(e.target.value)
                                    }
                                  />{" "}
                                  <strong>Card</strong>
                                </div>
                              ) : (
                                <div className="_p_wrp">
                                  <input
                                    type="radio"
                                    value="card"
                                    //disabled
                                    checked={paymentMethord === "card"}
                                    onChange={(e) =>
                                      setPaymentMethord(e.target.value)
                                    }
                                  />{" "}
                                  <strong>Card</strong>
                                </div>
                              )}
                              <div className="pay_wrp">
                                <img
                                  src={require("../../img/_pay.jpg")}
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>

                          {paymentMethord === "card" && (
                            <div className="payment_form">
                              <div className="payment_form">
                                <div className="paymen_wrp">
                                  <Elements
                                    stripe={stripePromise}
                                    options={options}
                                  >
                                    <InstantPaymentForm
                                      orderId={orderId}
                                      amount={amount}
                                      hanldPlaceOrder={hanldPlaceOrder}
                                    />
                                  </Elements>
                                </div>
                              </div>
                            </div>
                          )}

                          {paymentMethord !== "card" && (
                            <>
                              {btnLoading ? (
                                <div className="pay_btn">
                                  <span className="checkout">
                                    Please Wait...
                                  </span>
                                </div>
                              ) : (
                                <div className="pay_btn">
                                  <button
                                    className="checkout"
                                    onClick={hanldPlaceOrder}
                                  >
                                    Continue
                                  </button>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                        {error && (
                          <span
                            style={{ color: "#ff0000ff", fontSize: "14px" }}
                          >
                            {error}
                          </span>
                        )}{" "}
                        <br />
                        <span style={{ color: "#595959ff", fontSize: "14px" }}>
                          <IoIosWarning color="orange" size={20} /> Note: Please
                          do not close this page until your order is confirmed.
                        </span>
                        <br />
                        <span style={{ color: "#595959ff", fontSize: "14px" }}>
                          Order will be delivered after 48 hours
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {loading ? (
                    <>
                      <Loading />
                    </>
                  ) : (
                    <>
                      <div>
                        <Succsess />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Payment;
